import React from "react";

export const DATABASE_LABELS = { 1: "Gs1 Admin", 2: "Grp", 4: "Gi" };
export const ACCESS_TYPE_LABELS = { 1: "Web", 2: "API" };
export const PORTAL_ACCESS_LABELS = { 1: "Single Search", 2: "Bulk Search", 3: "Search Results" };

const accessLabels = (labels) => ({ value }) => {
  const names = `${value || ""}`
    .split(",")
    .filter(Boolean)
    .map((code) => labels[code] || code);

  return <span>{names.join(", ")}</span>;
};

export default accessLabels;
